/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Fragment, useEffect, useState } from "react";

import { baseButtonStyle, sizeStyleMap, ulStyle } from "./styles";

import type { Size } from "./types";
import type { ReactElement } from "react";
import type { FcWithoutChildren } from "types/fcWithoutChildren";

type TitleContentPair = {
  contentElement: ReactElement;
  title: string;
};

type Props = {
  contents: TitleContentPair[];
  defaultSelectedIndex?: number;
  onSelectTab?: (selectedTabIndex: number) => void;
  size?: Size;
};

const FIRST_TAB_INDEX = 0;

export const Tab: FcWithoutChildren<Props> = (props) => {
  const {
    contents,
    defaultSelectedIndex = FIRST_TAB_INDEX,
    onSelectTab,
    size = "medium",
  } = props;
  const [selectedTabIndex, setSelectedTabIndex] =
    useState(defaultSelectedIndex);

  // タブ数が減少して選択中のインデックスが範囲外になった場合、 FIRST_TAB_INDEX に戻す
  useEffect(() => {
    setSelectedTabIndex((currentTabIndex) => {
      if (currentTabIndex >= contents.length) {
        return FIRST_TAB_INDEX;
      }
      return currentTabIndex;
    });
  }, [contents.length]);

  const buttonStyle = [baseButtonStyle, sizeStyleMap[size]];

  return (
    <Fragment>
      <ul css={ulStyle}>
        {contents.map((titleContentPair, index) => {
          const { title } = titleContentPair;
          const handleSelectTab = () => {
            setSelectedTabIndex(index);
            onSelectTab?.(index);
          };
          const isSelected = index === selectedTabIndex;

          return (
            <li key={`${title}-${index}`}>
              <button
                aria-selected={isSelected}
                css={buttonStyle}
                role="tab"
                type="button"
                onClick={handleSelectTab}
              >
                {title}
              </button>
            </li>
          );
        })}
      </ul>

      {contents.map((titleContentPair, index) => {
        const { title, contentElement } = titleContentPair;
        const isSelectedTitle = index === selectedTabIndex;

        if (!isSelectedTitle) return null;

        return <Fragment key={`${title}-${index}`}>{contentElement}</Fragment>;
      })}
    </Fragment>
  );
};
